import { ConvertToShamsiDate } from "@/utils/utils";
import Image from "next/image";
import Link from "next/link";
import { ArrowLeft } from "lucide-react";
import { routes } from "@/constants/routes";

const ArticleCard = ({ props, mini = false, contentType = "article" }: {
  props: any,
  mini?: boolean,
  contentType?: "article" | "video"
}) => {
  const listStyle = mini ? {
    imageSize: "w-full md:w-40 h-40",
    gapSize: "gap-4 md:gap-6",
    titleSize: "text-lg",
  } : {
    imageSize: "w-full md:w-62.5 h-62.5",
    gapSize: "gap-4 md:gap-20",
    titleSize: "text-xl",
  };

  return (
    <li
      className={`flex flex-col md:flex-row items-center md:items-start justify-start 
              ${listStyle.gapSize} mb-4 px-3 py-4 border-b-[#d0d5dd] border-b
              w-full md:max-w-3xl hover:bg-gray-100 rounded-3xl 
              transition-all duration-300 ease-out hover:-translate-x-1
              shadow-[0px_16px_40px_20px_rgba(112,144,176,0.05)]`}
    >
      <div
        className={`relative shrink-0 overflow-hidden rounded-2xl ${listStyle.imageSize}`}
      >
        <Image
          src={props?.cover_image || "/assets/vector.svg"}
          alt="props thumbnail"
          placeholder="blur"
          blurDataURL="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mN88f7TfwAJBAP6X6u3VAAAAABJRU5ErkJggg=="
          fill
          sizes="(max-width: 768px) 100vw, 250px"
          className="object-cover"
        />
      </div>

      <section className="flex flex-col gap-4 p-2 w-full">
        <h2 className={`font-bold text-sec-title ${listStyle.titleSize}`}>{props?.title}</h2>
        <time
          dateTime={props?.created_at}
          className="text-xs text-inp mb-2">
          {ConvertToShamsiDate(props?.created_at)}
        </time>
        <p className="text-sec-text text-base line-clamp-2">{props?.summary}</p>
        <Link
          href={contentType === "video" ? `${routes.video_tutorials}/view/${props?.content_id}` : `/articles/content/${props?.content_id}`}
          className="flex items-center gap-1 text-primary mr-4"
        >
          ادامه مطلب
          <ArrowLeft size={18} />
        </Link>
      </section>
    </li>
  );
};

export default ArticleCard;